// extracted by mini-css-extract-plugin
module.exports = {"bannerHeader":"ConsentHeader_bannerHeader__3x_l0","closeButton":"ConsentHeader_closeButton__14HJq"};